module.exports = __webpack_public_path__ + "img/vertical_4_1_8003.bad01eba.png";